import PropTypes from 'prop-types';
import { Box } from '@mui/material';

Logo.propTypes = {
  sx: PropTypes.object
};

export default function Logo({ sx }:any) {
  return <Box component="img" src="/static/BRSlogo.png" sx={{borderRadius:1, width: 100, height: 50, ...sx }} />
}
